module.exports = __webpack_public_path__ + "static/img/czj.876db212.png";